import {
  Component,
  EventEmitter,
  Input,
  Output,
  forwardRef,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CheckboxChangeEvent } from 'primeng/checkbox';
@Component({
  selector: 'lib-input-checkbox',
  templateUrl: './input-checkbox.component.html',
  styleUrl: './input-checkbox.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputCheckboxComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class InputCheckboxComponent implements ControlValueAccessor {
  @Input() public label = ''; // Label for the checkbox
  @Input() public id = ''; // Id for the checkbox
  @Input() public disabled = false; // If the checkbox should be disabled
  @Input() public value = false; // Checkbox value
  @Output() public valueChange = new EventEmitter<boolean>();
  @Input() public mt = 16;
  @Input() public mb = 0;
  @Output() public checkboxChangeEventEmit =
    new EventEmitter<CheckboxChangeEvent>(); // Emits changes for external listeners

  // Initialize as no-op to avoid recursive calls.
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public onChange: (value: boolean) => void = () => {};
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public onTouched: () => void = () => {};

  // ControlValueAccessor methods
  public writeValue(value: boolean): void {
    this.value = value;
  }

  public registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  // Called when the checkbox value changes
  public onCheckboxChange(event: CheckboxChangeEvent): void {
    this.value = event.checked;
    this.onChange(this.value); // Notify the form of the value change
    this.onTouched(); // Mark as touched
    this.checkboxChangeEventEmit.emit(event);
    this.valueChange.emit(this.value);
  }
}
